"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var Opacity = /** @class */ (function (_super) {
    tslib_1.__extends(Opacity, _super);
    function Opacity(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.type = 'opacity';
        _this.names = ['opacity'];
        return _this;
    }
    return Opacity;
}(base_1.default));
exports.default = Opacity;
//# sourceMappingURL=opacity.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/attr/lib/attributes/opacity.js
// module id = 753
// module chunks = 37